<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>運搬方法</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  名称
                </div>
                <h4>{{ transportation.name }}</h4>
                <v-divider />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  コード
                </div>
                <h4>{{ transportation.code }}</h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  並び順
                </div>
                <h4>{{ transportation.position }}</h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  データ作成日時
                </div>
                <h4>{{ transportation.created_at | unix_datetime_format }}</h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="6">
                <div class="overline">
                  データ更新日時
                </div>
                <h4>{{ transportation.updated_at | unix_datetime_format }}</h4>
                <v-divider />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="error"
              @click="deleteButtonClickEvent"
            >
              削除
            </v-btn>
            <v-spacer />
            <v-btn
              color="info"
              @click="editButtonClickEvent"
            >
              編集
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from '../../../../components/Confirm'
export default {
  name: 'AdminMasterTransportationShow',
  components: {
    Confirm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '運搬方法一覧', disabled: false, to: '/admin/masters/transportations', exact: true },
        { text: '運搬方法詳細', disabled: true, to: '' },
      ],
      transportation: null,
    }
  },
  created() {
    this.transportation = {
      id: 1,
      code: 1,
      name: '車両',
      position: 1,
      created_at: 1633314402,
      updated_at: 1633314402,
    }
  },
  methods: {
    editButtonClickEvent () {
      this.$router.push({name: 'AdminMasterTransportationEdit', params: {id: this.quantity_unit.id}})
    },
    deleteButtonClickEvent () {
      let modalOption = { title: '削除', message: '運搬方法を削除します。よろしいですか？', options: { titleColor: 'red' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.$router.push({name: 'AdminMasterTransportations'})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
